<template>
  <div class="wrapper">
    <div class="title-section">
      <h1 class="type-title">{{ $t('footscan.foot_type__title') }}</h1>
      <h2 class="type-name text-purple-gradient">{{ footType.name }}</h2>
    </div>
    <div class="main-img-wrapper">
      <img :src="footType.img" :alt="footType.name" />
    </div>
    <div class="type-summary" v-html="footType.summary"></div>
    <div class="type-desc mb-4" v-html="footType.description"></div>
  </div>
</template>

<script>
import imgEgyptian from '@/assets/FootScan/toe-egyptian.svg';
import imgRoman from '@/assets/FootScan/toe-roman.svg';
import imgGreek from '@/assets/FootScan/toe-greek.svg';

export default {
  name: 'FootType',
  props: {
    measurement: {
      type: Object,
      default: () => ({
        left: { value: 1 },
        right: { value: 1 },
      }),
    },
  },
  computed: {
    typeIndex() {
      const { left } = this.measurement;
      return left.value;
    },
    footType() {
      const DATA = [
        {
          img: imgEgyptian,
          name: this.$i18n.t('footscan.foot_type__unknown'),
          summary: this.$i18n.t('footscan.foot_type__summary_unknown'),
          description: this.$i18n.t('footscan.foot_type__desc_unknown'),
        },
        {
          img: imgEgyptian,
          name: this.$i18n.t('footscan.foot_type__egyptian'),
          summary: this.$i18n.t('footscan.foot_type__summary_egyptian'),
          description: this.$i18n.t('footscan.foot_type__desc_egyptian'),
        },
        {
          img: imgRoman,
          name: this.$i18n.t('footscan.foot_type__roman'),
          summary: this.$i18n.t('footscan.foot_type__summary_roman'),
          description: this.$i18n.t('footscan.foot_type__desc_roman'),
        },
        {
          img: imgGreek,
          name: this.$i18n.t('footscan.foot_type__greek'),
          summary: this.$i18n.t('footscan.foot_type__summary_greek'),
          description: this.$i18n.t('footscan.foot_type__desc_greek'),
        },
      ];
      return DATA[this.typeIndex] || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  @apply relative flex flex-1 flex-col px-5 text-left;
  letter-spacing: 0;
  font-style: normal;
}
.type-title {
  @apply mt-5;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.type-name {
  @apply my-2;
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}
.main-img-wrapper {
  @apply px-5 mt-4;
  img {
    @apply w-full;
  }
}
.type-summary {
  @apply my-5;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
}
.type-desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #595959;
}
</style>
